/**
 * RTWO Asset & Token Engine — Asset Validation Service
 */

import type { AssetId } from '../domain-models';
import type { AssetValidationResult, IAssetValidationService } from '../service-interfaces';
import type {
  LedgerAdapterRegistry,
  ScrtRuntimeAdapterRegistry,
} from '../registry/adapter-registries';
import { ASSTInternalEventTypes } from '../events/ass-event-bus';
import { BaseASSService, type ASSServiceContext } from './base-ass-service';

export class AssetValidationService extends BaseASSService implements IAssetValidationService {
  readonly serviceId = 'ass-validation-service-001';
  readonly serviceName = 'Asset Validation Service';
  readonly description =
    'Asset validation — placeholder, requires real Validation Backend. No fake validation results.';
  readonly integrations = [
    'Core Engine',
    'Ledger Engine',
    'Cryptography Engine',
    'Smart Contract Runtime',
  ];
  readonly requiresLedgerConnection = true;
  readonly requiresTokenRuntime = false;

  constructor(
    context: ASSServiceContext,
    private readonly ledgerRegistry: LedgerAdapterRegistry,
    private readonly scrtRegistry: ScrtRuntimeAdapterRegistry
  ) {
    super(context);
  }

  async initialize(): Promise<void> {
    this.status = 'waiting_for_ledger_connection';
  }

  async validateAsset(assetId: AssetId): Promise<AssetValidationResult> {
    if (!this.ledgerRegistry.isConfigured() || !this.scrtRegistry.isConfigured()) {
      return {
        success: false,
        validationId: null,
        error: 'Asset validation requires real Validation Backend — Not Configured',
        isPlaceholder: true,
        source: 'Asset & Token Engine — Validation Backend Not Configured',
      };
    }

    const adapterResult = await this.scrtRegistry.getActiveAdapter().validateAsset(assetId);

    if (adapterResult) {
      this.context.eventBus.emit(ASSTInternalEventTypes.ASSET_VALIDATED, { assetId });
    }

    return {
      success: false,
      validationId: null,
      error: 'Asset validation requires real Validation Backend — Not Configured',
      isPlaceholder: true,
      source: 'Asset & Token Engine — Validation Backend Not Configured',
    };
  }

  getValidationCount(): 0 {
    return 0;
  }
}
